import {
  Component,
  OnInit,
  Output,
  ViewContainerRef,
  EventEmitter,
  SimpleChanges,
  HostListener,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Product } from '../../../models/product';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import { ApiService } from '../../../services/api.service';
import { UtilsService } from '../../../services/utils.service';
import { StopOnboardingModalComponent } from '../../../components/dialogs/stop-onboarding-modal/stop-onboarding-modal.component';
import {
  ModalDialogService,
  SimpleModalComponent,
  IModalDialogButton,
} from 'ngx-modal-dialog';
import { Input } from '@angular/core';

@Component({
  selector: 'alg-progress-header',
  templateUrl: './alg-progress-header.component.html',
  styleUrls: ['./alg-progress-header.component.scss'],
})
export class AlgProgressHeaderComponent implements OnInit {
  public currentOnBoarding: any;
  public isSaveAvailable = false;
  public websiteUrl: string = environment.websiteUrl;
  public product: Product = {} as Product;
  public screenWidth: any;
  public isTablet: boolean;
  public isProductPlacet: boolean;

  @Output() sendTypeStatusValue: EventEmitter<string> = new EventEmitter();
  @Output() currentStatus: EventEmitter<string> = new EventEmitter();

  @Input() currentStatusFromStep: string | null = null;

  constructor(
    private api: ApiService,
    private gtm: AlgGtmService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth > 767 && this.screenWidth < 993) {
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }
  }

  // tslint:disable-next-line: member-ordering
  public onbProgressConfig = {
    user_info: {
      value: 20,
      stepNumber: 1,
      title: 'Titolare della fornitura',
      duration: '2 min',
    },
    contract_info: {
      value: 50,
      stepNumber: 2,
      title: 'Dati Contrattuali',
      duration: '4 min',
    },
    supplies: {
      value: 75,
      stepNumber: 3,
      title: 'La tua fornitura',
      duration: '2 min',
    },
    payment: {
      value: 90,
      stepNumber: 4,
      title: 'Pagamento',
      duration: '2 min',
    },
    insurance: {
      value: 95,
      stepNumber: 5,
      title: 'Opzioni Aggiuntive',
      duration: '2 min',
    },
    summary: {
      value: 100,
      stepNumber: 6,
      title: 'Riepilogo',
      duration: '30 sec',
    },
  };

  public onbProgressConfigPlacet = {
    user_info: {
      value: 20,
      stepNumber: 1,
      title: 'Titolare della fornitura',
      duration: '2 min',
    },
    contract_info: {
      value: 50,
      stepNumber: 2,
      title: 'Dati Contrattuali',
      duration: '4 min',
    },
    supplies: {
      value: 75,
      stepNumber: 3,
      title: 'La tua fornitura',
      duration: '2 min',
    },
    payment: {
      value: 90,
      stepNumber: 4,
      title: 'Pagamento',
      duration: '2 min',
    },
    summary: {
      value: 100,
      stepNumber: 5,
      title: 'Riepilogo',
      duration: '30 sec',
    },
  };

  public stepsName = () => {
    if (this.isProductPlacet) {
      return Object.keys(this.onbProgressConfigPlacet);
    } else {
      return Object.keys(this.onbProgressConfig);
    }
  };
  public allSteps: any = [];
  public currentStepFound = { status: false, number: 0 };
  public progress = 0;

  public restartOnboarding() {
    this.gtm.submitOnbEvent('Click su Cancella tutto');
    window.location.href = `${window.location.origin}/?prd=${this.product.slug}`;
  }

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct)
      .subscribe(([currentOnBoarding, product]) => {
        if (!currentOnBoarding.webStatus) return;
        this.currentOnBoarding = currentOnBoarding;
        this.product = product;
        if (
          this.product &&
          !!this.product.family &&
          this.product.family.name === 'Placet'
        ) {
          this.isProductPlacet = true;
        }
        this.config();
        if (this.progress < 99) {
          // Avoid getting console error when uploading this component into Thank You Page
          if (this.progress !== 0) {
            this.progress =
              this.onbProgressConfig[currentOnBoarding.webStatus].value;
          }
        }
        this.isSaveAvailable =
          this.currentOnBoarding.email &&
          this.currentOnBoarding.email.length > 0 &&
          true;
      });
    this.screenWidth = window.innerWidth;
    if (this.screenWidth > 767 && this.screenWidth < 992) {
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }
  }

  openModal() {
    this.utils.disableOverflow();
    if (this.isSaveAvailable) {
      const data = { ...this.currentOnBoarding };
      data.sendEmail = true;
      this.api.saveOnboarding(data, true);
      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Salva e Sospendi',
        childComponent: StopOnboardingModalComponent,
        settings: {
          bodyClass: 'modal-body',
          modalDialogClass: 'modal-dialog',
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline',
        },
      });
    }
  }

  public sendTypeStatus(type) {
    console.log('SEND TYPE STATUS');
    if (
      this.onbProgressConfig[this.currentOnBoarding.webStatus].stepNumber <
      type.stepNumber
    )
      return;
    this.sendTypeStatusValue.emit(type.stepName);
    this.allSteps.map((e) => {
      e.edited = false;
      if (
        e.stepNumber === type.stepNumber &&
        this.onbProgressConfig[this.currentOnBoarding.webStatus].stepNumber !=
          type.stepNumber
      ) {
        e.edited = true;
        this.gtm.submitOnbEvent('clic su modifica step', e.stepNumber);
      }
    });
    return;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.allSteps.map((i) => {
      i.edited = false;
      if (i.stepName === changes.currentStatusFromStep.currentValue) {
        i.edited = true;
      }
    });
  }

  private config() {
    this.allSteps = [];
    this.currentStepFound = { status: false, number: 0 };

    if (this.isProductPlacet) {
      Object.keys(this.onbProgressConfigPlacet).map((e) => {
        this.onbProgressConfigPlacet[e].stepName = e;
        this.allSteps.push(this.onbProgressConfigPlacet[e]);
      });
    } else {
      Object.keys(this.onbProgressConfig).map((e) => {
        this.onbProgressConfig[e].stepName = e;
        this.allSteps.push(this.onbProgressConfig[e]);
      });
    }

    this.allSteps.sort((a, b) =>
      a.stepNumber < b.stepNumber ? -1 : a.stepNumber > b.stepNumber ? 1 : 0
    );
    this.allSteps.map((e) => {
      e.edited = false;
      e.surpassed = true;
      e.actual = false;
      if (e.stepName === this.currentOnBoarding.webStatus) {
        this.currentStepFound = { status: true, number: e.stepNumber };
        e.actual = true;
        this.currentStatus.emit(e.stepName);
      }
      if (this.currentStepFound.status) e.surpassed = false;
      return e;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-progress-header/alg-progress-header.component.ts